import * as go from 'gojs';
import { GOJS_CUSTOM_FIGURES } from '../utils/custom-figure-generator';

const $ = go.GraphObject.make;

export const leftColorStrip = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []): go.Shape =>
  $(
    go.Shape,
    {
      figure: GOJS_CUSTOM_FIGURES.RoundedLeftRectangle,
      fill: 'transparent',
      strokeWidth: 0,
      width: 7,
      height: 52,
      alignment: go.Spot.Top,
      ...props,
    },
    ...bindings,
  );
